import { useEffect } from "react";

import { useSessionResultsStaticContext } from "@Context/game/activity/session-results-context";
import { warmupReplayLoaderWorker } from "@hooks/game/activity/session/replay-loader-worker-client";
import { useSessionFeedbackModel } from "@hooks/game/activity/session/use-session-feedback-model";

const FeedbackPrefetch = () => {
  const { sessionResults, userId } = useSessionResultsStaticContext();

  useEffect(() => {
    warmupReplayLoaderWorker();
  }, []);

  useSessionFeedbackModel({
    currentTab: 0,
    cognitiveResultId: 0,
    userId: userId || "",
    sessionResults,
  });

  return null;
};

export default FeedbackPrefetch;
